var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-table',{attrs:{"paginated":"","view-mode":"","data":_vm.items}},[_c('b-table-column',{attrs:{"sortable":"","field":"Name","label":_vm.Catalog.Name.Label},scopedSlots:_vm._u([{key:"default",fn:function({ column, row }){return [_c('kst-value',{attrs:{"field":column.field,"data":row,"catalog":_vm.Catalog}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }